import { StringHelper } from "../../../../../../helper";
import { AFLType } from "../../models";

export const form10 = (record: any) => {
  return {
    departmentCode: "2",
    aflType: AFLType.AccidentLeaveApplication,
    layout: [
      {
        type: "header",
        value: {
          form: 2,
          department: StringHelper.verticalBarSplit(record?.eDepartment)[1],
        },
      },
      {
        type: "title",
        value: { sub: [] },
      },
      {
        type: "salutation",
        value: [
          "- Ông Giám đốc;",
          "- Trưởng phòng/trung tâm",
          "- Trưởng phòng Tổ chức hành chính.",
        ],
      },
      {
        type: "content",
        value: [
          { type: "eRequestName", value: record?.eRequestName },
          { type: "eEmployeeId", value: record?.eEmployeeId },
          {
            type: "eWorkPlace",
            value: StringHelper.verticalBarSplit<string[]>(record?.eUnit)[1],
          },
          {
            type: "",
            value:
              "Nay tôi làm đơn này kính đề nghị Ông Giám đốc, Trưởng phòng/trung tâm đồng ý giải quyết cho tôi được nghỉ với thời gian như sau:",
          },

          { type: "eVacationPeriod", value: record?.eVacationPeriod },
          {
            type: "eExpectedReturnDate",
            value: record?.eExpectedReturnDate,
          },
          { type: "eReason", value: record?.eReason },
          {
            type: "",
            value:
              "Rất mong nhận được sự chấp thuận của Ông Giám đốc, Trưởng phòng/trung tâm.",
          },
          { type: "", value: "Xin trân trọng cảm ơn." },
        ],
      },

      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["TRƯỞNG PHÒNG TCHC", record?.eApprovalProcess[3][0].name],
          },
          {
            type: "signature1",
            value: ["THỦ TRƯỞNG ĐƠN VỊ", record?.eApprovalProcess[1][0].name],
          },
          {
            type: "signature1",
            value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
          },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "recipients",
            value: [
              "- Như trên;",
              "- TCHC (để biết);",
              "- Lưu: phòng/trung tâm. ",
            ],
          },
          {
            type: "signature1",
            value: [
              "PHÊ DUYỆT CỦA GIÁM ĐỐC",
              record?.eApprovalProcess[4][0].name,
            ],
          },
        ],
        textBreak: 1,
      },
    ],
  };
};
